<div class="file-upload-content">
    <div class="file-upload-header">
        <h3>{{'fileupload.title'|translateTA}}</h3>
        <p>{{'fileupload.explain'|translateTA}}</p>
    </div>
    <div class="tool-bar">
        <input type="file" class="file-input" hidden
        [accept]="fileOptions.fileTypeUpload"
        [multiple]="fileOptions.multipleFiles"
        (change)="onFileSelected($event)" #fileUpload>

        <button nz-button nzType="primary" nzShape="circle" nz-tooltip="Selecionar arquivos"
            (click)="fileUpload.click()">
            <nz-icon nzType="paper-clip"></nz-icon>
        </button>
        <button nz-button nzType="primary" nzShape="circle" nz-tooltip="Enviar arquivos"
            (click)="sendFiles()" [disabled]="disableUpload">
            <nz-icon nzType="cloud-upload"></nz-icon>
        </button>
    </div>
    <div class="list-container" #listcontainer>
        <div class="item-file-upload" *ngFor="let item of files; let i = index">
            <div class="item-file-upload-info">
                <span>{{item.index}}</span>-<span>{{item.filename}}</span> - <span>{{item.filetype}}</span>:<span>{{item.size/1024 | number:'1.0-0'}} KB</span>
            </div>

            <nz-progress class="progress-bar" [nzPercent]="item.progress || 0" nzSize="small" [nzShowInfo]="false"></nz-progress>

            <nz-icon class="cancel-upload" nzType="close-circle" (click)="cancelUpload()"
                *ngIf="item.progress>0 && item.progress<100"></nz-icon>

            <nz-icon class="cancel-upload" nzType="delete" (click)="removeFile(i)"
                *ngIf="(item.progress==0||item.progress==null) && canDelete"></nz-icon>

            <nz-icon class="waiting-upload" nzType="clock-circle"
                *ngIf="(item.progress==0||item.progress==null) && !canDelete"></nz-icon>

            <nz-icon class="error-upload" nzType="warning" nzTheme="fill" nz-tooltip [nzTooltipTitle]="item.error"
                *ngIf="(item.error!=null)"></nz-icon>

            <nz-icon class="done-upload" nzType="check-circle" nzTheme="fill"
                *ngIf="item.progress==100 && (item.error==null)"></nz-icon>
        </div>
    </div>

    <div class="file-upload-footer">
        <span *ngIf="files.length>0">{{'fileupload.totalfiles'|translateTA}}: {{files.length}}</span>
        <span *ngIf="files.length>0">{{'fileupload.totalsize'|translateTA}}: {{totalSize | number:'1.0-0'}} MB</span>
    </div>

    <div class="action-image-buttons" *ngIf="fileOptions.showCloseButton">
        <actions-buttons [buttonList]="buttonList" [data]="files"></actions-buttons>
    </div>

</div>
